import { requireField } from './validators';

export default class StudentNote {
  constructor(data = {}) {
    requireField(data.content, 'note.content');

    this.id = data.id || `note-${Math.random().toString(36).slice(2, 9)}`;
    this.content = data.content;
    this.createdAt = data.createdAt || new Date().toISOString();
    this.createdBy = data.createdBy || 'System';
  }

  toJSON() {
    return { ...this };
  }
}
